import storage from './localStorage';

/**
 * Ключ в локальном хранилище браузера, под которым сохраняются
 * данные аутентифицированного пользователя.
 */
const STORAGE_ITEM_KEY = 'auth.user';

export default {
  /**
   * @param {Object} userData
   * @returns void
   */
  setUser(userData) {
    storage.setItem(STORAGE_ITEM_KEY, userData, false);
  },

  /**
   * @returns void
   */
  removeUser() {
    storage.removeItem(STORAGE_ITEM_KEY, false);
  },

  /**
   * @param {Function<Object>} listener
   * @returns void
   */
  addUserListener(listener) {
    storage.addStorageListener(STORAGE_ITEM_KEY, listener);
  }
};
